export default __webpack_public_path__ + "static/media/background.93abeb71.jpg";